// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","imgcontainer":"App_imgcontainer__1qTwV"};